import { statusMeta, TONE_CLASSES } from "@/lib/statuses";

export const StatusBadge = ({ status, size = "md" }) => {
  const meta = statusMeta(status);
  const Icon = meta.icon;
  const pad = size === "sm" ? "px-2.5 py-0.5 text-xs" : "px-3 py-1 text-sm";
  return (
    <span
      data-testid="shipment-status-badge"
      className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${pad} ${TONE_CLASSES[meta.tone]}`}
    >
      <Icon className={size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4"} strokeWidth={2} />
      {meta.label}
    </span>
  );
};
